import { render, staticRenderFns } from "./contractorArea.vue?vue&type=template&id=5bcab4ac&"
import script from "./contractorArea.vue?vue&type=script&lang=js&"
export * from "./contractorArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports